import { render, staticRenderFns } from "./LiabilitiesDetailsOverview.vue?vue&type=template&id=1032e0e6&scoped=true&"
import script from "./LiabilitiesDetailsOverview.vue?vue&type=script&lang=js&"
export * from "./LiabilitiesDetailsOverview.vue?vue&type=script&lang=js&"
import style0 from "./LiabilitiesDetailsOverview.vue?vue&type=style&index=0&id=1032e0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1032e0e6",
  null
  
)

export default component.exports